import httpClient from './http-client';
import mockServiceService from './service.service.mock';

let serviceService;

if (process.env.NODE_ENV === 'development') {
  serviceService = mockServiceService;
} else {
  serviceService = {
    // params: locale, type, status, group, periodStart, periodEnd, orderBy, page, pageSize
    getList(params) {
      return httpClient.get('/service', { params });
    },
  };
}

export default serviceService;
